import { createReducer, on } from '@ngrx/store';

import * as fromRootImpeActions from '@apps/root/store/impersonate/impe.actions';
import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';
import * as fromMiscStoreActions from '@apps/back/store/misc/misc.actions';
import { PartialEntity } from '@apps/back/models/partial-entity';
import { PartialUser } from '@apps/back/models/partial-user';

export const BackMiscFeatureKey = 'misc';

export interface IBackMiscState
{
    entity: PartialEntity;
    user: PartialUser;
}

const InitialState: IBackMiscState = {
    entity: null,
    user: null
};

export const BackMiscReducer = createReducer(
    InitialState,
    on(
        fromRootImpeActions.RootImpersonateSet,
        fromRootImpeActions.RootImpersonateUnset,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        fromAuthLoginActions.AuthLogout,
        () =>
            InitialState
    ),
    on(
        fromMiscStoreActions.BackEntityDetailsInMemorySaveRequested,
        (state: IBackMiscState, { entity }: { entity: PartialEntity }) =>
        {
            return {
                ...state,
                entity: entity
            };
        }
    ),
    on(
        fromMiscStoreActions.BackUserDetailsSaveRequested,
        (state: IBackMiscState, { user }: { user: PartialUser }) =>
        {
            return {
                ...state,
                user: user
            };
        }
    ),
    on(
        fromMiscStoreActions.BackEntityDetailsWasSelected,
        (state: IBackMiscState, { entity }: { entity: PartialEntity }) => ({
            ...state,
            entity: entity
        })
    ),
    on(
        fromMiscStoreActions.BackUserDetailsLoadSucceeded,
        (state: IBackMiscState, { user }: { user: PartialUser }) => ({
            ...state,
            user: user
        })
    )
);
